// extracted by css-extract-rspack-plugin
export default {"trigger":"src-shared-components-MainLayout-components-UserProfile-UserProfilePopover-UserProfilePopover-module__trigger-qCZX3t","popover":"src-shared-components-MainLayout-components-UserProfile-UserProfilePopover-UserProfilePopover-module__popover-B4fUbT"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"trigger\":\"src-shared-components-MainLayout-components-UserProfile-UserProfilePopover-UserProfilePopover-module__trigger-qCZX3t\",\"popover\":\"src-shared-components-MainLayout-components-UserProfile-UserProfilePopover-UserProfilePopover-module__popover-B4fUbT\"}";
        // 1793875576443
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  